/**
 * Initializes Google Preferred Source SDK
 */
export function initGooglePreferredSource() {
  (self.PREFERRED_SOURCE = self.PREFERRED_SOURCE || []).push(
    function (preferredSource) {

      preferredSource.init({
        theme: "light",
        lang: "en"
      });

      var buttons = document.querySelectorAll(
        ".google-preferred-source-btn"
      );

      buttons.forEach(function (button) {
        button.addEventListener("click", function (e) {
          e.preventDefault();

          preferredSource.addPreferredSource();
        });
      });

    }
  );
}

export function initCookieBar() {
  // Check if the cookie is already set
  var hasCookie = document.cookie.indexOf("ModalShown=true") >= 0;

  if (hasCookie) {
    // Remove the cookie bar immediately to prevent it from showing
    document.querySelectorAll(".cookie-bar").forEach(function (element) {
      element.remove();
    });
    return; // Exit early
  }

  // Set opacity of cookie bar to 1 only if the cookie is NOT set
  document.querySelectorAll(".cookie-bar").forEach(function (element) {
    element.style.opacity = "1";
  });

  var now = new Date();
  var time = now.getTime();
  var expireTime = time + 30 * 24 * 60 * 60 * 1000;
  now.setTime(expireTime);

  var cookieButton = document.getElementById("cookie-button");
  if (cookieButton) {
    cookieButton.addEventListener("click", function () {
      document.cookie = "ModalShown=true; expires=" + now.toUTCString() + ";path=/";
    });
  }

  // Cookie hide show animation
  var cookieBtn = document.querySelector(".cookie-bar .cookie-bar-inner #cookie-button");
  if (cookieBtn) {
    cookieBtn.addEventListener("click", function () {
      var cookieBar = cookieBtn.closest(".cookie-bar");
      if (cookieBar) {
        // Slide up simulation
        cookieBar.style.transition = "all 300ms ease";
        cookieBar.style.height = cookieBar.offsetHeight + "px";
        // Force reflow
        cookieBar.offsetHeight;
        cookieBar.style.height = "0";
        cookieBar.style.paddingTop = "0";
        cookieBar.style.paddingBottom = "0";
        cookieBar.style.marginTop = "0";
        cookieBar.style.marginBottom = "0";
        cookieBar.style.overflow = "hidden";
        cookieBar.style.opacity = "0";

        setTimeout(function () {
          cookieBar.remove();
        }, 300);
      }
    });
  }
}


export function initDmcabadge() {
  var e = "footer-meta-dmca";
  var t = "refurl";
  var n = document.querySelectorAll('a.' + e);
  
  if (n.length > 0 && n[0].getAttribute("href") && n[0].getAttribute("href").indexOf("refurl") < 0) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.href = i.href + (i.href.indexOf("?") === -1 ? "?" : "&") + t + "=" + document.location;
    }
  }
}
